import * as ActionTypes from '../actions'
import { combineReducers } from 'redux'



const doctors = (state = null, action) => {
	switch (action.type) {
		case ActionTypes.LOAD_GLOBALS_SUCCESS:
			return action.response.search.doctors || null
		case ActionTypes.LOAD_GLOBALS_FAILURE:
			return null
		default:
			return state
	}
}

const users = (state = null, action) => {
	switch (action.type) {
		case ActionTypes.LOAD_GLOBALS_SUCCESS:
			return action.response.search.users || null
		case ActionTypes.LOAD_GLOBALS_FAILURE:
			return null
		default:
			return state
	}
}

const plants = (state = null, action) => {
	switch (action.type) {
		case ActionTypes.LOAD_GLOBALS_SUCCESS:
			return action.response.search.plants || null
		case ActionTypes.LOAD_GLOBALS_FAILURE:
			return null
		default:
			return state
	}
}

const actions = (state = null, action) => {
	switch (action.type) {
		case ActionTypes.LOAD_GLOBALS_SUCCESS:
			return action.response.search.actions || null
		case ActionTypes.LOAD_GLOBALS_FAILURE:
			return null
		default:
			return state
	}
}

const patients = (state = null, action) => {
	switch (action.type) {
		case ActionTypes.LOAD_GLOBALS_SUCCESS:
			return action.response.search.patients || null
		case ActionTypes.LOAD_GLOBALS_FAILURE:
			return null
		default:
			return state
	}
}

const searchReducer = combineReducers({
	doctors,
	users,
	plants,
	actions,
	patients
})

export default searchReducer


// WEBPACK FOOTER //
// ./src/reducers/search.js